import { action } from 'mobx';

import { AppManager, Variables } from 'core/index';

import { StoryConnManager } from 'apps/story/main/appManager';

import { InitiativeStoriesQuery } from 'apps/story/gql';

export class InitiativeStoriesManager extends AppManager {
  constructor(parent, init = {}) {
    super(parent, init);
    this.variables = new Variables({
      storiesCursor: () => null,
      storiesCount: () => {
        if (
          this.storiesConn.arrayApp.length > this.storiesConn.initialBatchSize
        ) {
          return this.storiesConn.batchSize;
        }
        return this.storiesConn.initialBatchSize;
      },
      storiesSortBy: () => this.storiesConn.sortBy,
    });
    this.storiesConn = new StoryConnManager(this, {
      sortBy: 'recent',
      initialBatchSize: 4,
      loadMoreQuery: InitiativeStoriesQuery,
    });
    this.variables.onChange(['slug'], this.HandleNewSlug);
  }

  @action
  HandleNewSlug = () => {
    this.storiesConn.Reset();
    this.NewInitiativeStoriesQuery();
  };

  @action
  NewInitiativeStoriesQuery = () => {
    this.storiesConn.loadMore();
  };
}
